<template>
  <li
    class="board_list_wrap pnt"
    @click="goDetail(item.id, type, item.reportCount)"
  >
    <div class="board_list_top" v-if="item.reportCount == 0">
      <div class="list_con">
        <div class="list_txt_1">
          <span class="list_new" v-if="isNew(item.createdAt)">
            <img :src="require(`@/assets/front/images/i_new2.svg`)" alt="" />
          </span>
          <span class="list_keyword" v-if="type == 'knowhow'">{{
            categories[item.category]
          }}</span>
          <span classs="list_title">{{ item.title }}</span>
        </div>
        <div class="list_txt_2">
          <span class="txt_1">{{ item.createdAt | moment('from') }}</span>
          <span class="txt_2" v-if="type == 'knowhow' && item.areaName != ''">{{
            item.areaName
          }}</span>
        </div>
        <div class="list_txt_3">
          <div class="txt">
            <div class="txt_img">
              <i class="i_list_like"></i>
            </div>
            <div class="txt_count">{{ item.likeCnt }}</div>
          </div>
          <div class="txt">
            <div class="txt_img">
              <i class="i_list_eye"></i>
            </div>
            <div class="txt_count">{{ item.readCnt }}</div>
          </div>
          <div class="txt">
            <div class="txt_img">
              <i class="i_list_reply"></i>
            </div>
            <div class="txt_count">{{ item.replyCnt }}</div>
          </div>
        </div>
      </div>
      <div class="list_img" v-if="item.imagePath">
        <img :src="item.imagePath" alt="" />
      </div>
    </div>
    <div class="board_list_top" v-else>
      <div class="report_cnt">
        신고가 접수되어 임시 블라인드 처리된 게시물 입니다.
      </div>
    </div>
  </li>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
export default {
  name: 'community-board-list',
  props: {
    item: Object,
    type: String,
  },
  data() {
    return {
      categories: {
        MOBILE: '휴대폰',
        INTERNET: '인터넷',
        MVNO: '알뜰폰',
        PLAN: '요금제',
        RENTAL: '렌탈',
        STORE: '매장',
      },
    };
  },
  created() {
    // alert(this.item.createdAt);
  },
  computed: {},
  methods: {
    isNew(createdAt) {
      const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
      const create = new Date(createdAt);
      const create_24 = format(
        new Date(create.setDate(create.getDate() + 1)),
        'yyyy-MM-dd HH:mm:ss',
      );

      return now < create_24;
    },
    goDetail(boardId, boardType, reportCount) {
      if (reportCount == 0) {
        if (boardType == 'knowhow') {
          this.$router.push({
            name: 'Knowhow.Detail',
            params: { id: boardId, isRead: 'Y' },
            hash: '#',
          });
        } else {
          this.$router.push({
            name: 'Board.Detail',
            params: { id: boardId, isRead: 'Y' },
            hash: '#',
          });
        }
      }
    },
  },
};
</script>
